<template>
    <div id="app">
        <HeaderBlock></HeaderBlock>
        <Developments></Developments>
        <quote
            quote="Vision is the art of seeing things invisible"
            attribution="Jonathan Swift"
        ></quote>
        <Giving></Giving>
        <quote
            quote="A ray of imagination or of wisdom may enlighten the universe, and glow into remotest centuries."
            attribution="Bishop George Berkeley<br><small>17th/18th century philosopher and one of Kilkenny College’s most distinguished alumni.</small>"
            variant="secondary"
        ></quote>
        <Faqs></Faqs>
        <footer-main></footer-main>
        <BackToTop></BackToTop>
        <Modal></Modal>
    </div>
</template>

<script>
import HeaderBlock from "@/components/HeaderBlock.vue"
import Developments from "@/components/Developments.vue"
import Quote from "@/components/Quote.vue"
import Giving from "@/components/Giving.vue"
import Faqs from "@/components/Faqs.vue"
import FooterMain from "@/components/FooterMain.vue"
import Modal from "@/components/Modal.vue"
import BackToTop from "@/components/BackToTop.vue"

export default {
    name: "app",
    components: {
        HeaderBlock,
        Developments,
        Quote,
        Giving,
        Faqs,
        FooterMain,
        Modal,
        BackToTop,
    },
}
</script>

<style lang="scss">
*,
*:after,
*:before {
    box-sizing: border-box;
}

html {
    @include base-typography;

    @include iosgo {
        overflow-x: hidden;
        overflow-y: scroll;
    }

    overflow-x: hidden; // fix wave overflow bug
}

body {
    // overflow-x: hidden;
    max-width: 100%;
    height: 100% !important;
    margin: 0 auto;
    color: var(--primary_font_colour);
    background: var(--primary_font_colour);
    position: relative;
    @include base-typography;
}

.wrapper {
    position: relative;
    width: var(--wrapper_width);
    max-width: 90%;
    min-height: 100%;
    margin: 0 auto;
}

.wrapper--narrow {
    width: var(--wrapper_narrow_width);
    max-width: 90%;
    min-height: 100%;
    margin: 0 auto;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
}
h1,
h2 {
    @include titleText();
}

h3,
h4,
h5 {
    font-weight: 400;
}

img {
    max-width: 100%;
    height: auto;
}

section {
    @include sectionPad();
    position: relative;
    background-color: var(--quaternary_colour);
    overflow-x: hidden;

    @include mobile {
        overflow: hidden;
    }
}

@font-face {
    font-family: "#{$icomoon-font-family}";
    src: url("#{$base_path}fonts/#{$icomoon-font-family}.ttf?6zi43e")
            format("truetype"),
        url("#{$base_path}fonts/#{$icomoon-font-family}.woff?6zi43e")
            format("woff"),
        url("#{$base_path}fonts/#{$icomoon-font-family}.svg?6zi43e##{$icomoon-font-family}")
            format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

.icon {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "#{$icomoon-font-family}" !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.icon-icon-back-to-top {
    &:before {
        content: $icon-icon-back-to-top;
    }
}

.icon-icon-tick {
    &:before {
        content: $icon-icon-tick;
    }
}

.icon-icon-play {
    &:before {
        content: $icon-icon-play;
    }
}

.icon-icon-give {
    &:before {
        content: $icon-icon-give;
    }
}

.icon-icon-download {
    &:before {
        content: $icon-icon-download;
    }
}

.icon-icon-donate {
    &:before {
        content: $icon-icon-donate;
    }
}

.icon-icon-brochure {
    &:before {
        content: $icon-icon-brochure;
    }
}
</style>
